import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { ReactNode } from "react";
import { ProgressLine } from "../ProgressLine";

type InfoSectionProps = {
  title: string;
  description?: string;
  htmlDescription?: boolean;
  lineComponent?: ReactNode;
  progressBarLabel?: string;
  barPercent: number;
};

export const InfoSection = ({
  title,
  description,
  htmlDescription = false,
  lineComponent,
  progressBarLabel,
  barPercent,
}: InfoSectionProps) => (
  <PageWrapper backgroundColor="section_dark">
    <div className={s.blueBelt}>
      <h2 className={s.blueBelt__title}>{title}</h2>
      {!!description && (
        <>
          {lineComponent ? (
            <ProgressLine text={progressBarLabel} width={`${barPercent}%`} />
          ) : (
            <div className={s.blueBelt__line} />
          )}
          {htmlDescription ? (
            <p
              className={s.blueBelt__description}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          ) : (
            <p className={s.blueBelt__description}>{description}</p>
          )}
        </>
      )}
    </div>
  </PageWrapper>
);
